import { render } from "./DeleteManyPurchasesModal.vue?vue&type=template&id=897162a0&scoped=true"
import script from "./DeleteManyPurchasesModal.vue?vue&type=script&lang=js"
export * from "./DeleteManyPurchasesModal.vue?vue&type=script&lang=js"

import "./DeleteManyPurchasesModal.vue?vue&type=style&index=0&id=897162a0&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-897162a0"]])

export default __exports__